var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("report-toolbar", {
                attrs: {
                  "set-default-props": _vm.setDefaultButtonProps,
                  "report-props": Object.assign({}, _vm.runningReport, {
                    disabled: _vm.$v.$invalid,
                  }),
                },
                on: {
                  "reset-to-default": _vm.resetToDefaultValues,
                  "set-default": _vm.setDefaultValues,
                  "run-report": _vm.handleRunReport,
                  "clear-selection": _vm.handleClearSelection,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.loading
        ? _c("firm-statistics-loader")
        : _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.level")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                              _vm._v(" "),
                              !_vm.CURRENT_ACCOUNT_IS_BROKER
                                ? _c("icon", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        value: {
                                          title: _vm.$t(
                                            "application-reports.firm-statistics.selectAgentMessage"
                                          ),
                                        },
                                        expression:
                                          "{\n                title: $t(\n                  'application-reports.firm-statistics.selectAgentMessage'\n                )\n              }",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    staticClass: "text-primary clickable ml-1",
                                    attrs: { name: "info-circle" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-level", {
                            attrs: {
                              "selected-level":
                                _vm.firmStatisticsValues.selectedLevel,
                            },
                            on: {
                              "update:selectedLevel": function ($event) {
                                return _vm.$set(
                                  _vm.firmStatisticsValues,
                                  "selectedLevel",
                                  $event
                                )
                              },
                              "update:selected-level": function ($event) {
                                return _vm.$set(
                                  _vm.firmStatisticsValues,
                                  "selectedLevel",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showAgentsSelect
                        ? _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", sm: "6" },
                            },
                            [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "bold mb-1 form-title font-sm text-capitalize",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$tc("global.doorr.agent", 1)) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("agents-select", {
                                    attrs: {
                                      id: "select-agents-reports",
                                      value:
                                        _vm.firmStatisticsValues.selectedAgents,
                                      "select-options": _vm.options,
                                      "extra-select-data": [
                                        _vm.allAgentsOption,
                                      ],
                                      "default-value":
                                        _vm.firmStatisticsValues.selectedAgents,
                                      label: "",
                                      "has-checkboxes": "",
                                      "space-classes":
                                        "form-group-material form-group-material-no-label",
                                      "close-on-select-all": "",
                                    },
                                    on: { change: _vm.handleSelectAgentChange },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.format")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-format", {
                            attrs: {
                              "selected-format":
                                _vm.firmStatisticsValues.selectedFormat,
                            },
                            on: {
                              "update:selectedFormat": function ($event) {
                                return _vm.$set(
                                  _vm.firmStatisticsValues,
                                  "selectedFormat",
                                  $event
                                )
                              },
                              "update:selected-format": function ($event) {
                                return _vm.$set(
                                  _vm.firmStatisticsValues,
                                  "selectedFormat",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applicationStatus"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-application-status", {
                            attrs: {
                              clearable: true,
                              multiple: "",
                              "selected-application-status":
                                _vm.firmStatisticsValues
                                  .selectedApplicationStatus,
                              action: "clear",
                            },
                            on: {
                              "update:selectedApplicationStatus": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.firmStatisticsValues,
                                  "selectedApplicationStatus",
                                  $event
                                )
                              },
                              "update:selected-application-status": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.firmStatisticsValues,
                                  "selectedApplicationStatus",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applications-summary.dateType"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { id: "select-date-type", "no-label": "" },
                              model: {
                                value: _vm.firmStatisticsValues.dateType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.firmStatisticsValues,
                                    "dateType",
                                    $$v
                                  )
                                },
                                expression: "firmStatisticsValues.dateType",
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.dateTypeOptions,
                                  placeholder: _vm.$t(
                                    "global.actions.chooseOption"
                                  ),
                                  value: _vm.firmStatisticsValues.dateType,
                                  clearable: false,
                                  label: "text",
                                  "default-value":
                                    _vm.firmStatisticsValues.dateType,
                                },
                                on: {
                                  "option:selected": function (ref) {
                                    var id = ref.id

                                    return (_vm.firmStatisticsValues.dateType =
                                      id)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.dateFrom"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-from",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "max-date":
                                            _vm.firmStatisticsValues.dateTo,
                                        },
                                        model: {
                                          value:
                                            _vm.firmStatisticsValues.dateFrom,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.firmStatisticsValues,
                                              "dateFrom",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "firmStatisticsValues.dateFrom",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("application-reports.dateTo")
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-to",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "min-date":
                                            _vm.firmStatisticsValues.dateFrom,
                                        },
                                        model: {
                                          value:
                                            _vm.firmStatisticsValues.dateTo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.firmStatisticsValues,
                                              "dateTo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "firmStatisticsValues.dateTo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-4 mb-3", attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  value: {
                                    title: _vm.$t(
                                      "application-reports.firm-statistics.airMessage"
                                    ),
                                  },
                                  expression:
                                    "{\n              title: $t('application-reports.firm-statistics.airMessage')\n            }",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass: "d-inline-block",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-capitalize mr-2",
                                  attrs: { for: "air-check" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-reports.firm-statistics.annualInformationReturn"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-jelly p-smooth p-curve",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.firmStatisticsValues.filterForAIR,
                                        expression:
                                          "firmStatisticsValues.filterForAIR",
                                      },
                                    ],
                                    staticClass: "checkbox",
                                    attrs: {
                                      id: "air-check",
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.firmStatisticsValues.filterForAIR
                                      )
                                        ? _vm._i(
                                            _vm.firmStatisticsValues
                                              .filterForAIR,
                                            null
                                          ) > -1
                                        : _vm.firmStatisticsValues.filterForAIR,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a =
                                              _vm.firmStatisticsValues
                                                .filterForAIR,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.firmStatisticsValues,
                                                  "filterForAIR",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.firmStatisticsValues,
                                                  "filterForAIR",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.firmStatisticsValues,
                                              "filterForAIR",
                                              $$c
                                            )
                                          }
                                        },
                                        _vm.handleChangeAIR,
                                      ],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "state p-success" },
                                    [
                                      _c("i", {
                                        staticClass: "icon fa fa-check",
                                      }),
                                      _vm._v(" "),
                                      _c("label", [
                                        _c(
                                          "span",
                                          { staticStyle: { display: "none" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "application-reports.firm-statistics.annualInformationReturn"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }